import {
  SET_CAMPAIGNS,
  SET_CAMPAIGNS_SEARCHED,
  SET_SORT_VALUE,
  SET_SEARCH_VALUE,
  EDIT_CAMPAIGN,
  SET_SCALING_STATUS,
} from "../types";

const ScalingReducer = (state, action) => {
  switch (action.type) {
    case SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload };

    case SET_CAMPAIGNS_SEARCHED:
      return { ...state, campaigns_searched: action.payload };

    case SET_SORT_VALUE:
      return { ...state, sort_value: action.payload };

    case SET_SEARCH_VALUE:
      return { ...state, search_value: action.payload };

    case EDIT_CAMPAIGN: {
      const { index_selected, campaign_selected } = action.payload;
      return { ...state, index_selected, campaign_selected };
    }

    case SET_SCALING_STATUS:
      return { ...state, scaling_status: action.payload };

    default:
      return state;
  }
};

export default ScalingReducer;